import Image from "next/image";
import type { PropsWithChildren } from "react";
import { Skeleton } from "~/components/ui/Skeleton";
import styles from "./gallery.module.css";

export const Gallery = ({
	url,
	alt,
	children,
	secondImage,
}: PropsWithChildren<{
	url: string;
	alt?: string;
	secondImage?: {
		href?: string;
		alt?: string;
	};
}>) => {
	return (
		<div className={styles.root}>
			<div className={styles["product-card__image"]} product-card-image="true">
				{url !== "" ? (
					<Image
						src={url ?? "/"}
						alt={alt ?? "Main product image"}
						width={1000}
						height={1250}
						sizes={"(min-width: 768px) 30vw, 50vw"}
					/>
				) : (
					<div
						style={{
							backgroundColor: "var(--color-primary-20)",
							height: "100%",
						}}
					/>
				)}
				{secondImage?.href && (
					<div className={styles["second-image"]}>
						<Image
							src={secondImage.href}
							width={1000}
							height={1250}
							alt={secondImage.alt ?? "Second product image"}
							sizes={"(min-width: 768px) 30vw, 50vw"}
						/>
					</div>
				)}

				{children}
			</div>
		</div>
	);
};

export const GallerySkeleton = () => {
	return (
		<div className={styles.root}>
			<div className={styles["product-card__image"]} product-card-image="true">
				<Skeleton height="100%" />
			</div>
		</div>
	);
};
